var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatesCounter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    zoomAndPan: "magnify",
    viewBox: "0 0 1024.5 1307.999939",
    height: 1744,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ae0d914224"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 237 337.160156 L 1014 337.160156 L 1014 961.605469 L 237 961.605469 Z M 237 337.160156 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ae0d914224)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 687.664062 920.089844 L 734.734375 754.636719 L 801.941406 754.636719 L 749.75 937.933594 C 745.84375 951.808594 733.050781 961.503906 718.707031 961.503906 C 708.539062 961.503906 699.109375 956.789062 692.984375 948.640625 C 686.789062 940.425781 684.835938 929.988281 687.664062 920.089844 Z M 582.679688 478.8125 L 617.160156 478.8125 L 617.160156 720.15625 L 582.679688 720.15625 Z M 324.09375 336.859375 L 548.203125 471.335938 L 548.203125 727.027344 L 324.09375 846.554688 Z M 789.550781 478.8125 L 789.550781 720.15625 L 651.636719 720.15625 L 651.636719 478.8125 Z M 858.503906 478.8125 L 858.503906 720.15625 L 824.027344 720.15625 L 824.027344 478.8125 Z M 983.890625 520.023438 C 1023.421875 565.34375 1023.421875 633.625 983.890625 678.945312 C 964.835938 700.832031 938.574219 714.769531 910.222656 718.8125 L 910.222656 480.15625 C 938.574219 484.128906 964.769531 498.070312 983.890625 520.023438 Z M 247.796875 635.375 C 234.667969 613.625 234.597656 586.554688 248 563.929688 C 257.226562 548.304688 272.378906 537.195312 289.617188 532.75 L 289.617188 666.285156 C 272.378906 661.910156 257.160156 650.933594 247.796875 635.375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 144.902344 483.1875 C 103.890625 560.5625 108.605469 653.960938 157.292969 726.890625 L 185.914062 707.765625 C 144.363281 645.410156 140.324219 565.542969 175.40625 499.28125 L 144.902344 483.1875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 104.160156 458.675781 L 75.476562 439.550781 L 53.859375 472.078125 C 0.257812 552.414062 0.257812 656.183594 53.859375 736.519531 L 75.476562 768.980469 L 104.160156 749.855469 L 82.546875 717.398438 C 36.6875 648.710938 36.6875 559.886719 82.546875 491.203125 L 104.160156 458.675781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatesCounter);
export default __webpack_public_path__ + "static/media/updates_counter.aac011deb95a4d4f80f56675785e39a3.svg";
export { ForwardRef as ReactComponent };